import * as HostBrowserApis from '~/utils/host-browser-apis'
import type { BaseHostConfig } from '~/types/index'

function useHostBrowserConfig() {
  const config = ref<BaseHostConfig | undefined>()

  onBeforeMount(async () => {
    config.value = await HostBrowserApis.getConfig()
  })

  return config
}

export default useHostBrowserConfig
